import React from "react";
import { Outlet } from "react-router";
import { CircularProgressBox } from "src/ui/shared/CircularProgressBox";
import { usePrefetch } from "src/ui/utils/usePrefetch";

import { TechnicalDifficultiesFallback } from "@shared/TechnicalDifficultiesFallback";

export const PrefetchGuard = () => {
    const { progress, hasPrefetchError, isResolvingWorkspace } = usePrefetch();

    if (hasPrefetchError) {
        return <TechnicalDifficultiesFallback />;
    }

    if (isResolvingWorkspace) {
        return null;
    }

    if (progress !== 100) {
        return <CircularProgressBox value={progress} size="large" />;
    }

    return <Outlet />;
};
